import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './ConnectionsList.scss';
import { Item } from 'semantic-ui-react';
import ConnectionItem from './ConnectionItem';

export default class ConnectionsList extends React.Component {

  get class() {
    return `${css['list']} ${this.props.wrapOnMediumScreens ? css['list-m'] : ''}`;
  }

  render() {
    return (
      <Item.Group unstackable className={this.class} role="application">
        {this.props.connections.map(c => (
          <ConnectionItem
            key={c.personId}
            personId={c.personId}
            uuid={c.uuid}
            fullName={c.fullName}
            email={c.email}
            phoneNumber={c.phoneNumber}
            roles={c.roles}
            photoAvailable={c.photoAvailable}
            onlineSchedulingAvailable={c.onlineSchedulingAvailable}
            title={c.title}
            serviceId={this.props.serviceId}
          />
        ))}
      </Item.Group>
    );
  }
}

ConnectionsList.defaultProps = {
  wrapOnMediumScreens: false
};

ConnectionsList.propTypes = {
  wrapOnMediumScreens: PropTypes.bool.isRequired,
  connections: PropTypes.arrayOf(PropTypes.shape({
    personId: SFEntityID.isRequired,
    uuid: PropTypes.string,
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    photoAvailable: PropTypes.bool,
    onlineSchedulingAvailable: PropTypes.bool,
    roles: PropTypes.array.isRequired,
    title: PropTypes.string
  })).isRequired,
  serviceId: SFEntityID
};
